
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import loadable from '@loadable/component'
import * as serviceWorker from './serviceWorker';
import { BrowserRouter as Router, Route, Link, Redirect } from 'react-router-dom'
import { message } from 'antd'
const Home = loadable(() => import('./Pages/home'))
const Dynamic = loadable(() => import('./Pages/dynamic/Dynamic'))
const Introduce = loadable(() => import('./Pages/introduce/Introduce'))
const Review = loadable(() => import('./Pages/review/Review'))
const Enroll = loadable(() => import('./Pages/enroll/Enroll'))
const News = loadable(() => import('./Pages/news/News'))
const PlayerToReg = loadable(() => import('./Pages/playerToReg/PlayerToReg'))
const ToFindPassword = loadable(() => import('./Pages/toFindPassword/ToFindPassword'))
const UploadMaterials = loadable(() => import('./Pages/uploadMaterials/UploadMaterials'))
const Personalinformation = loadable(() => import('./Pages/personalinformation/Personalinformation'))
const Registrationexamine = loadable(() => import('./Pages/registrationinformation/Registrationexamine'))
const Registrationfalse = loadable(() => import('./Pages/registrationinformation/Registrationfalse'))
const Registrationsuccess = loadable(() => import('./Pages/registrationinformation/Registrationsuccess'))
const Registerednot = loadable(() => import('./Pages/registrationinformation/Registerednot'))
const Signup = loadable(() => import('./Pages/signup/Signup'))
const Winnerlist = loadable(() => import('./Components/winnerlist/Winnerlist'))
const CaseManagement = loadable(() => import('./Pages/case-management/CaseManagement'))
const ProcessDescription = loadable(() => import('./Pages/processDescription/ProcessDescription'))
const Entryinformation = loadable(() => import('./Pages/entryinformation/Entryinformation'))
const Entryinformationdetails = loadable(() => import('./Pages/entryinformation/Entryinformationdetails'))
const Uploadentryinformation = loadable(() => import('./Pages/uploadentryinformation/Uploadentryinformation'))
const EntryKnow = loadable(() => import('./Pages/entryKnow/EntryKnow'))

const Admin = loadable(() => import('./AdminRoute'))

message.config({
  top: 400,
  duration: 4,
  maxCount: 1,
});
ReactDOM.render(
  <React.StrictMode>
    <Router>
        {/* 前台内容 */}
        <Route path="/" exact component={Home} />
        <Route path="/home" component={Home} />
        <Route path="/introduce" component={Introduce} />
        <Route path="/dynamic/:page"  exact component={Dynamic} />
        <Route path="/tofindpassword" component={ToFindPassword}/>
        <Route path="/review" exact component={Review} />
        <Route path="/review/winnerlist/:id" component={Winnerlist} />
        <Route path="/enroll" exact component={Enroll} />
        <Route path="/enroll/:id" exact component={Enroll} />
        <Route path="/dynamic/:page/news/:id" component={News} />
        <Route path="/reg" component={PlayerToReg} />
        <Route path="/signup" exact component={Signup} />
        <Route path="/processdescription" component={ProcessDescription} />
        <Route path="/entryknow" component={EntryKnow} />
        {/* 资料上传页  */}
        <Route path="/touploadmaterials"  component={UploadMaterials} />  
        <Route path="/caseManagement" component={CaseManagement} />
        <Route path="/personalinformation" exact component={Personalinformation} />
        <Route path="/registrationexamine" exact component={Registrationexamine} />
        <Route path="/registrationfalse" exact component={Registrationfalse} />
        <Route path="/registrationsuccess" exact component={Registrationsuccess} />
        <Route path="/registerednot" exact component={Registerednot} />
        <Route path="/entryinformation" exact component={Entryinformation} />
        <Route path="/entryinformationdetails" exact component={Entryinformationdetails} />
        <Route path="/uploadentryinformation" exact component={Uploadentryinformation} />
        <Route path="/uploadentryinformation/:id" exact component={Uploadentryinformation} />
  
        {/* 管理后台入口 */}
        <Route path="/admin_page" component={Admin} />
      </Router>
  </React.StrictMode>,
  document.getElementById('root')
);



// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
